/** The offering total. Sibling rows carry product categories (`jbp-pc-commercial`, …), so summing
 *  everything would double-count. Declared here rather than imported from
 *  `legacy/lut/components/widgets/public/partner360/planning/config` — a feature does not reach
 *  into legacy widget internals. */
export const OVERALL_CATEGORY = 'jbp-overall'

/** `fQuarter` `1`–`4` are quarters; `5` is the full-year total. */
export const FULL_YEAR_QUARTER = 5

/** The year's last quarter — the one in which the next year gets planned. */
export const LAST_FQUARTER = 4
